import { render, staticRenderFns } from "./InputPassengers.vue?vue&type=template&id=016350b3&scoped=true&"
import script from "./InputPassengers.vue?vue&type=script&lang=js&"
export * from "./InputPassengers.vue?vue&type=script&lang=js&"
import style0 from "./InputPassengers.vue?vue&type=style&index=0&id=016350b3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016350b3",
  null
  
)

export default component.exports